import { render } from "./NavBar.vue?vue&type=template&id=bd93b646"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__